import {CompanyFeesResource} from '@/common/api/api-raw-types';
import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
import UserResource from '@/brief-hub/user/UserResource';

export class CompanyFeesService {
    public async fetchDefaultFees(): Promise<HttpServiceResponse<CompanyFeesResource>> {
        return await context.httpService.get<CompanyFeesResource>(context.registry.entries.defaultFees());
    }

    public async fetchUserFees(user: UserResource): Promise<HttpServiceResponse<CompanyFeesResource>> {
        return await context.httpService.get<CompanyFeesResource>(user.links.companyFees());
    }
}
